import { useEffect, useState } from "react";
import { Bell, Check } from "lucide-react";
import api from "../lib/api";
import { Spinner, EmptyState } from "../components/states";
import PublicLayout from "../components/PublicLayout";
import { BackButton, Breadcrumbs, ExternalLink, useEscape } from "../lib/nav";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => api.get("/notifications").then((r) => { setItems(r.data); setLoading(false); }).catch(() => setLoading(false));
  useEffect(() => { load(); }, []);
  const readAll = async () => { await api.patch("/notifications/read-all"); load(); };
  const read = async (id) => { await api.patch(`/notifications/${id}/read`); load(); };

  const color = { success: "#10B981", warning: "#FF9F1C", error: "#ef4444", info: "#E8552A" };

  return (
    <PublicLayout>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8">
        <BackButton fallback="/dashboard" className="mb-4" />
        <div className="flex items-center justify-between">
          <h1 className="font-display text-3xl font-extrabold uppercase flex items-center gap-3"><Bell className="text-[#E8552A]" /> Notifications</h1>
          <button data-testid="read-all-btn" onClick={readAll} className="mono-label text-[#E8552A] flex items-center gap-1 hover:underline"><Check size={14} /> READ ALL</button>
        </div>
        {loading ? <Spinner /> : items.length === 0 ? <EmptyState title="No notifications" icon={Bell} /> : (
          <div className="space-y-3 mt-6">
            {items.map((n) => (
              <div key={n.id} data-testid={`notification-${n.id}`} onClick={() => !n.read && read(n.id)}
                className={`card-copper rounded-xl p-4 cursor-pointer ${n.read ? "opacity-60" : ""}`}>
                <div className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full mt-2 shrink-0" style={{ background: color[n.level] || "#E8552A" }} />
                  <div className="flex-1">
                    <p className="font-display font-semibold text-sm">{n.title}</p>
                    <p className="text-sm text-[#A1A1AA] mt-0.5">{n.message}</p>
                    <p className="mono-label text-[#71717A] mt-1">{new Date(n.created_at).toLocaleString()}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </PublicLayout>
  );
}
